import { createQueryKey } from '../../../../query/createQueryKeyFactory';
import { QueryKey } from '../../../../query/types';

const ticketingDashboardEventsKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'events'] as const;
  return createQueryKey({
    all: [...key] as const,
  });
};

export { ticketingDashboardEventsKeys };
